<div class="flex">
  <div class="flex-item">
    @if (dashboardService.loadingCheckoutDate || showLoader) {
      <div class="loading-div">
        @if (dashboardService.loadingCheckoutDate) {
          <mat-spinner diameter="80" class='full-center-spinner'></mat-spinner>
        }
      </div>
    }
    <div class="chart-container square">
      @if (chartData) {
        <canvas baseChart
          [data]="chartData"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [type]="barChartType"
        ></canvas>
      }
    </div>
  </div>
</div>
